import { __exports as GenericBarcode } from "./index182.js";
import { __require as requireBarcode } from "./index158.js";
var hasRequiredGenericBarcode;
function requireGenericBarcode() {
  if (hasRequiredGenericBarcode) return GenericBarcode;
  hasRequiredGenericBarcode = 1;
  Object.defineProperty(GenericBarcode, "__esModule", {
    value: true
  });
  GenericBarcode.GenericBarcode = void 0;
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var GenericBarcode$1 = (function(_Barcode) {
    _inherits(GenericBarcode2, _Barcode);
    function GenericBarcode2(data, options) {
      _classCallCheck(this, GenericBarcode2);
      return _possibleConstructorReturn(this, (GenericBarcode2.__proto__ || Object.getPrototypeOf(GenericBarcode2)).call(this, data, options));
    }
    _createClass(GenericBarcode2, [{
      key: "encode",
      value: function encode() {
        return {
          data: "10101010101010101010101010101010101010101",
          text: this.text
        };
      }
      // Resturn true/false if the string provided is valid for this encoder
    }, {
      key: "valid",
      value: function valid() {
        return true;
      }
    }]);
    return GenericBarcode2;
  })(_Barcode3.default);
  GenericBarcode.GenericBarcode = GenericBarcode$1;
  return GenericBarcode;
}
export {
  requireGenericBarcode as __require
};
//# sourceMappingURL=index143.js.map
